import { FolderModel, FolderType } from '../../../../gamma-api';

export const isEmptyFolder = (folder?: FolderModel): boolean | undefined => {
  if (!folder) {
    return undefined;
  }

  return !folder.projects.length && !folder.chat_agents.length && !folder.api_agents.length && !folder.toolkits.length;
};

export const isExportableFolder = (folder: FolderModel): boolean => {
  return !isEmptyFolder(folder);
};

export const isDeletableFolder = (folder: FolderModel): boolean => {
  return folder.type === FolderType.Custom;
};
